import React from "react"
import ToolTip from "react-portal-tooltip"
import strings from "../../localization/strings"
import FontIcon from "material-ui/FontIcon"
import { green500, grey500 } from "material-ui/styles/colors"
import {
	IDate, EPunchSetApprovalType, IPunchSetDocument, IPayrollPunchSet,
	IExpenseDocument, IPunchSetApproval, IExpensesPayrollData
} from "../../models"
import UserCheck from "../../../assets/icons/user-check"
import moment from "moment"
import * as timecardHelper from "../../helpers/timecardHelper"

interface IProps {
	identify: string
	width: number
	toolTipPosition: "top" | "right" | "left" | "bottom"
	toolTipArrow: "center" | "right" | "left" | "top" | "bottom"
	approvalType: EPunchSetApprovalType
	punchSets: (IPunchSetDocument | IPayrollPunchSet)[]
	expenses: (IExpenseDocument | IExpensesPayrollData)[]
	handleApproveStatus?(status: "unapprove" | "approve"): void

	locked?: boolean
}
interface IState {
	open: boolean
	allApproved: boolean
	latestApprovalDetails: IPunchSetApproval
}

export default class ApproveIcon extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props)
		const approvalData = this.getApprovalData(props)
		this.state = {
			open: false,
			allApproved: approvalData.allApproved,
			latestApprovalDetails: approvalData.latestApprovalDetails
		}
	}

	componentWillReceiveProps(nextProps: IProps) {
		const approvalData = this.getApprovalData(nextProps)
		this.setState({
			allApproved: approvalData.allApproved,
			latestApprovalDetails: approvalData.latestApprovalDetails
		})
	}

	getApprovalData(props: IProps) {
		let latestApproveDateTime: IDate = moment("2000-01-01").format()
		let latestApprovalDetails: IPunchSetApproval = null
		const approvedPropertyName = props.approvalType === EPunchSetApprovalType.ExtSupervisor ?
			"ExtSupApproved" :
			props.approvalType === EPunchSetApprovalType.Employee ?
				"EmployeeApproved" :
				"SupervisorApproved"
		const approvalDetailPropertyName = props.approvalType === EPunchSetApprovalType.ExtSupervisor ?
			"ExtSupApprovalDetails" :
			props.approvalType === EPunchSetApprovalType.Employee ?
				"EmployeeApprovalDetails" :
				"SupervisorApprovalDetails"
		const approvalDetalsList: IPunchSetApproval[] = []
		const punchSets = props.punchSets || []
		const expenses = props.expenses || []

		const allApproved = timecardHelper.getApproveState(punchSets as IPunchSetDocument[], expenses as IExpenseDocument[], this.props.approvalType)
		punchSets.forEach((item: (IPunchSetDocument | IPayrollPunchSet)) =>
			item[approvedPropertyName] && item[approvalDetailPropertyName] && item[approvalDetailPropertyName].ApproverName !== "SYSTEM" &&
			approvalDetalsList.push(item[approvalDetailPropertyName])
		)
		expenses.forEach(item =>
			item[approvedPropertyName] && item[approvalDetailPropertyName] && item[approvalDetailPropertyName].ApproverName !== "SYSTEM" &&
			approvalDetalsList.push(item[approvalDetailPropertyName])
		)

		approvalDetalsList.forEach(item => {
			if (moment(latestApproveDateTime).isBefore(moment(item.ApprovedDateTime))) {
				latestApprovalDetails = item
				latestApproveDateTime = latestApprovalDetails.ApprovedDateTime
			}
		})

		return { allApproved, latestApprovalDetails }
	}

	render() {
		if ((this.props.punchSets || []).length + (this.props.expenses || []).length === 0) return null
		if (!this.state.allApproved && !this.props.handleApproveStatus) return null
		const iconColor = this.state.allApproved ? green500 : grey500
		const marginValue = this.props.width > 20 ? 10 : 4
		return (
			<div
				id={this.props.identify}
				onMouseOver={() => this.state.allApproved && this.setState({ open: true })}
				onMouseOut={() => this.setState({ open: false })}
				onClick={this.props.locked !== true && this.props.handleApproveStatus ?
					e => {
						e.stopPropagation()
						this.props.handleApproveStatus(this.state.allApproved ? "unapprove" : "approve")
					} :
					null
				}
				title={!this.state.allApproved ? strings.Approve : ""}
				style={{ marginLeft: marginValue, marginRight: marginValue }}
			>
				<ToolTip active={this.state.open} position={this.props.toolTipPosition} arrow={this.props.toolTipArrow} parent={"#" + this.props.identify}>
					{this.state.allApproved && (
						this.state.latestApprovalDetails ?
							<div style={{ paddingLeft: 15, paddingRight: 15, textAlign: "center" }}>
								<span style={{ fontWeight: 600 }}>
									{this.props.approvalType === EPunchSetApprovalType.ExtSupervisor ?
										strings.External_Approved :
										strings.Approved
									}
								</span>
								<br />
								<span>
									{this.state.latestApprovalDetails.ApproverName}
								</span>
								<br />
								{this.state.latestApprovalDetails.Title && [
									<span key="title">
										{this.state.latestApprovalDetails.Title}
									</span>,
									<br key="title line" />
								]}
								<span>
									{moment(this.state.latestApprovalDetails.ApprovedDateTime).format("MM/DD/YYYY h:mmA")}
								</span>
								<br />
								{[EPunchSetApprovalType.Employee, EPunchSetApprovalType.ExtSupervisor].includes(this.props.approvalType) && this.state.latestApprovalDetails.SignatureImageS3Url &&
									<img src={this.state.latestApprovalDetails.SignatureImageS3Url} style={{ maxWidth: 200 }} />
								}
							</div> :
							<div style={{ paddingLeft: 15, paddingRight: 15, textAlign: "center" }}>{strings.System_Approved}</div>
					)}
				</ToolTip>
				{this.props.approvalType === EPunchSetApprovalType.ExtSupervisor ?
					<FontIcon className="fa fa-check-double" style={{ fontSize: this.props.width, color: iconColor }} /> :
					this.props.approvalType === EPunchSetApprovalType.Supervisor ?
						<FontIcon className="fa fa-check-circle" style={{ fontSize: this.props.width, color: iconColor }} /> :
						<UserCheck color={iconColor} width={this.props.width * 1.25} height={this.props.width} />
				}
			</div >
		)
	}
}